<div
  class="fixed top-0 left-0 bg-black/20 h-full w-full backdrop-blur-[2px] z-1210 flex justify-center items-center"
  [class.hidden]="!isOpen()"
>
  <div
    class="bg-white rounded-lg p-4 flex flex-col max-h-full"
    [class]="styleClass()"
  >
    <div class="w-full flex justify-between shrink-0">
      <h2
        class="text-gray-400 text-lg md:text-xl max-w-[95%] overflow-hidden whitespace-nowrap text-ellipsis"
        [title]="title()"
      >
        {{ title() }}
      </h2>
      <button
        class="cursor-pointer text-gray-400 hover:text-gray-500 transition duration-200 ease-in-out"
        (click)="onCloseModal()"
      >
        <fa-icon [icon]="closeIcon" />
      </button>
    </div>
    <hr class="border-gray-300 border-1 my-4" />
    <div class="flex-1 min-h-0 overflow-y-auto">
      <ng-content />
    </div>
  </div>
</div>
